var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-view"},_vm._l((_vm.tabs),function(tab,i){return _c('div',{key:i,class:{
			tab: true,
			active: _vm.value == tab.value
		},on:{"click":function($event){return _vm.onChange($event, tab)}}},[_vm._v(_vm._s(tab.label)),(tab.badge && tab.badge.visible)?_c('div',{key:i,staticClass:"badge",style:({
			backgroundColor: '#a9a9a9',
			color: 'white',
			marginLeft: tab.label ? '7px' : '0'
		})},[_vm._v(_vm._s(tab.badge.label))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }